<template>
    <!-- scegli la zona -->
    <div class="container-md container-app p-0 ">
        <div class="wrapper login">
            <h1 class="title-nobkg text-center"><b>{{$t('scegli_zona')}}</b></h1><br>
            <div class="content text-center">
                <ul class="locali">
                    <li v-for="point in this.punti_di_servizio">
                        <a href="#" @click.prevent="handleZone(point)">
                            {{point.traduzione.nome}}
                        </a>
                    </li>
                </ul>
                <br>
                <button v-if="!!$route.query.canGoBack" class="btn btn-default btn-sm" @click="$router.go(-1)">
                    « {{$t('btn_indietro')}}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState, mapGetters, mapActions} from 'vuex';

export default {
    name: "ZoneSelect",
    computed: {
        ...mapState('restaurant', {
            locali: state => state.locali,
            punti_di_servizio: state => state.punti_di_servizio,
            franchising: state => state.franchising
        }),
        ...mapGetters('order', {
            cartMustBeReset: 'cartMustBeReset'
        })
    },
    methods: {
        handleZone: function (zone) {
            if (this.franchising && zone.conf_ordini_prenotazioni_pds.length > 1) {
                this.$router.push({
                    name: 'rooms',
                    query: {
                        canGoBack: this.$route.query.canGoBack,
                        service: this.$route.query.service,
                        pointId: zone.id
                    }
                });
            } else if (zone.conf_ordini_prenotazioni_pds.length) {
                const room = this.locali.find((locale) => {
                    return zone.conf_ordini_prenotazioni_pds[0].id_locale === locale.id;
                });

                const resetHome = (reset) => {
                    if (reset) {
                        this.resetOrder();
                    }
                    this.setLocale(room);
                    this.setDefaultParams({
                        id_punto_di_servizio_default: zone.id,
                        type_default: this.$route.query.service
                    });
                    this.$router.push({name: 'home'});
                }

                if (this.cartMustBeReset(room.id)) {
                    this.showModalCartReset({
                        show: true,
                        callback: (success) => {
                            if (success) {
                                resetHome(true);
                            }
                        }
                    });
                } else {
                    resetHome(false);
                }
            }
        },
        ...mapActions('global', [
            'showModalCartReset'
        ]),
        ...mapActions('restaurant', [
            'setLocale'
        ]),
        ...mapActions('order', {
            setDefaultParams: 'setDefaultParams',
            resetOrder: 'reset'
        })
    }
}
</script>
